import { getBrand } from '../utils/getBrand';

export default function FunnelFooterWithLinks({ showJustAllRightsReserved = false } = {}) {
  const { brandName, brandSupportEmail } = getBrand();

  // Minimal footer when only copyright should be shown
  if (showJustAllRightsReserved) {
    return (
      <footer className="relative mx-auto max-w-[1440px] w-full text-white opacity-70">
        © 2026 {brandName}. All rights reserved.
      </footer>
    );
  }
  return (
    <footer className="relative mx-auto max-w-[1440px] w-full">
      <div className="bg-black rounded-[28px] text-white px-4 py-8 md:py-10 md:px-12">
        <div className="flex flex-col gap-6">
          {/* Top row: links right-aligned on desktop, centered and stacked on mobile */}
          <div className="flex flex-col md:flex-row md:justify-between md:items-center border-b border-white/20 pb-4 gap-4 md:gap-0">
            <div className="hidden md:block w-1/2" />
            <div className="flex flex-col md:flex-row items-start md:justify-end gap-4 md:gap-8 w-full md:w-1/2 whitespace-nowrap">
              <a href="/privacy-policy" className="hover:underline">
                Privacy Policy
              </a>
              <a href="/terms-and-conditions" className="hover:underline">
                Terms & Conditions
              </a>
              <a href="/contact-us" className="hover:underline">
                Contact Us
              </a>
              {/* <a href="/about-us" className="hover:underline">
                About Us
              </a> */}
            </div>
          </div>
          {/* Bottom row: copyright left, contact right on desktop; stacked and centered on mobile */}
          <div className="flex flex-col-reverse md:flex-row md:justify-between md:items-center gap-6 md:gap-0">
            <div className="flex-1 text-left">
              <div className="text-xs text-white/50">© 2026 {brandName}. All rights reserved.</div>
              {/* <div className="text-xs text-white/50 max-w-xl mx-auto md:mx-0">
                *It is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout.
                The point of using Lorem Ipsum is that it has a more-or-less
                normal distribution of letters, as opposed to using 'Content
                here, content here', making it look like readable English.
              </div> */}
            </div>

            <div className="flex flex-col md:flex-row items-center md:items-center justify-center md:justify-end">
              {/* <div className="flex items-center gap-2 w-full">
                <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
                  <path
                    d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c(.127).96(.361) 1.903(.7) 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c(.907).339 1.85(.573) 2.81(.7)A2 2 0 0 1 22 16.92z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <a href="tel:+18664415396" className="hover:underline">
                  +1 (866) 441-5396
                </a>
              </div> */}
              <div className="flex items-center gap-2 border-b border-white/20 md:border-none w-full pb-6 md:pb-0">
                <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
                  <path
                    d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M22 6l-10 7L2 6"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <a className="text-[14px] hover:underline" href={`mailto:${brandSupportEmail}`}>
                  {brandSupportEmail}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
